import {UIElement} from "../ui/ui";
import {ColumnTypeEnum, TableColumn, TableWithFilters, TextTableFilter} from "../ui/TableWithFilters";
import '/modules/common/css/layer/IndicatorSummary.css';
import {nnTrim, prefixUrl} from "../util";

class IndicatorsSummary extends UIElement{
    constructor(code, indicators) {
        super(code);
        this.indicators = indicators;
    }

    getClassName() {
        return 'IndicatorsSummary';
    }


    getUIElement() {
        if(!this.uiElement){
            this._generateTable();
            this.uiElement = $('<div>').addClass('indicators-summary-container').append(this.table.getUIElement());
            this.enableObservationUnderUIElement();
        }
        return this.uiElement;
    }

    _generateTable(){
        const tableColumns = [
            new TableColumn('prodCode', ColumnTypeEnum.CODE, '#Product code', 100, true, true),
            new TableColumn('name', ColumnTypeEnum.STRING, '#Name', undefined, true, true),
            new TableColumn('srvCode', ColumnTypeEnum.CODE, '#Service code', 90, true, true),
            new TableColumn('periodicity', ColumnTypeEnum.STRING, '#Periodicity', 150, true, true),
            new TableColumn('start', ColumnTypeEnum.DATE, '#Since', 90, true, true),
            new TableColumn('until', ColumnTypeEnum.DATE, '#Until', 90, true, true),
            new TableColumn('ftpUrl', ColumnTypeEnum.LINK, '#FTP dir', 90, true, false),
        ];
        const colCodes = tableColumns.map(c => c.getCode());
        const filter = new TextTableFilter(this.code+'_table_text_filter', '#Filter', (columns, row, value) => {
            const prodCode = row[colCodes.indexOf('prodCode')];
            const name = row[colCodes.indexOf('name')];
            const srvCode = row[colCodes.indexOf('srvCode')];
            const periodicity = row[colCodes.indexOf('periodicity')];
            return prodCode.includesIgnoringSpecial(value) || name.includesIgnoringSpecial(value) || srvCode.includesIgnoringSpecial(value) || (!periodicity || periodicity.includesIgnoringSpecial(value));
        });
        this.table = new TableWithFilters(this.code+'_table', tableColumns, [filter], undefined, undefined, this._getData());
    }

    _getData() {
        const data = [];
        const prodCodes = new Set();
        this.indicators.forEach(i => {
            const service = i.getServiceConfig();
            let products = i.getTimeScales().map(t => i.getProductConfigForTimeScale(t));
            if (products.length === 0)
                products.push(i.getProductConfig());
            products =[...new Map(products.map(p => [p.getCode(), p])).values()];

            const already = products.filter(p => prodCodes.has(p.getCode()));
            if(already.length > 0)
                this.logDebug("["+i.getCode()+"]\tAlready exiting",already.map(p => p.getCode()));
            products = products.filter(p => !prodCodes.has(p.getCode())); //filter out any products that were already processed (referenced by other indicators)
            products.map(p => {
                prodCodes.add(p.getCode()); //add this product to the already processed products list
                const ftpUrl = nnTrim(p.config.ftpUrl?.default);
                return {
                    prodCode: p.getCode(),
                    name: p.getName(),
                    srvCode: service.getCode(),
                    periodicity: p.getPeriodicity()?.getLocalizedName(),
                    start: p.getDataFrom(),
                    until: p.getDataUntil(),
                    ftpUrl: prefixUrl(ftpUrl)
                };
            }).forEach(d => data.push(d));
        })
        return data;
    }
}

export {IndicatorsSummary};